var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "operationBut", attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.getList()
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", { attrs: { prop: "name", label: "学生姓名" } }),
          _c("el-table-column", {
            attrs: { prop: "avatar", label: "学生头像", width: "260" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("el-image", {
                      staticStyle: { width: "60px", height: "60px" },
                      attrs: { src: row.avatar, fit: "cover" }
                    })
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", { attrs: { prop: "age", label: "年龄" } }),
          _c("el-table-column", {
            attrs: { label: "性别" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.sex == 1
                      ? _c("span", [_vm._v("男")])
                      : _c("span", [_vm._v("女")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "status_text", label: "审核状态" }
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "320",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    row.status == 2
                      ? _c("div", { staticClass: "x-c" }, [
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.updateStudentInfo.init(row)
                                }
                              }
                            },
                            [_vm._v("配置信息")]
                          ),
                          _c("div", { staticClass: "controlsBtn-vertical" }),
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.capacityManage.init(row)
                                }
                              }
                            },
                            [_vm._v("能力管理")]
                          ),
                          _c("div", { staticClass: "controlsBtn-vertical" }),
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.studentcomment.init(row)
                                }
                              }
                            },
                            [_vm._v("评价学生")]
                          ),
                          _c("div", { staticClass: "controlsBtn-vertical" }),
                          _c(
                            "div",
                            {
                              staticClass: "controlsBtn",
                              on: {
                                click: function($event) {
                                  return _vm.$refs.disciplineList.init(row)
                                }
                              }
                            },
                            [_vm._v("记录统计")]
                          )
                        ])
                      : _vm._e(),
                    row.status == 0
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              placement: "bottom",
                              effect: "light",
                              "visible-arrow": "true"
                            }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.passClick(row.id)
                                      }
                                    }
                                  },
                                  [_vm._v("通过")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary", size: "mini" },
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.unseal.init(row.id)
                                      }
                                    }
                                  },
                                  [_vm._v("拒绝")]
                                )
                              ],
                              1
                            ),
                            _c("div", { staticClass: "controlsBtn" }, [
                              _vm._v("审核")
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length
        ? _c("el-pagination", {
            attrs: {
              layout: "total, prev, pager, next",
              "current-page": _vm.paramsData.page,
              total: _vm.total,
              "page-size": 10
            },
            on: { "current-change": _vm.getList }
          })
        : _vm._e(),
      _c("unseal", {
        ref: "unseal",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("updateStudentInfo", {
        ref: "updateStudentInfo",
        attrs: { teamId: _vm.teamId },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("capacityManage", {
        ref: "capacityManage",
        attrs: { teamId: _vm.teamId },
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("studentcomment", {
        ref: "studentcomment",
        on: {
          change: function($event) {
            return _vm.getList(_vm.paramsData.page)
          }
        }
      }),
      _c("disciplineList", { ref: "disciplineList" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }